import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { Provider } from "react-redux"
import store from "./redux/store"

//------ USER NOT AUTHENTICATE
import Artisti from './page/userNotAuth/artisti';
import CercaFoodTruck from './page/userNotAuth/components/cercaFoodTruck';
import Civita from './page/userNotAuth/Località/civita'
import CosaFare from './page/userNotAuth/cosaFare'
import DisabledNotificaEmail from './page/Authentication/disabledNotificaEmail'
import EventiDetails from './page/userNotAuth/eventiDetails';
import Firenze from './page/userNotAuth/Località/firenze';
import Fornitori from './page/userNotAuth/fornitori';
import FoodTruck from './page/userNotAuth/foodTruck';
import FoodTruckPerGenere from './page/userNotAuth/foodTruckPerGenere';
import Home from './page/userNotAuth/home';
import Login from './page/Authentication/login';
import Logout from './page/Authentication/logout';
import Matera from './page/userNotAuth/Località/matera'
import Newsletter from './page/userNotAuth/newsletter';
import NewsletterDetails from './page/userNotAuth/newsletterDetails'
import Orvieto from './page/userNotAuth/Località/orvieto';
import ReimpostaPassword from './page/Authentication/reimpostaPassword'
import ReimpostaEmail from './page/Authentication/reimpostaEmail'
import Register from './page/Authentication/register'
import RegisterSuccess from './page/Authentication/registerSuccess'
import Roma from './page/userNotAuth/Località/roma'
import Venezia from './page/userNotAuth/Località/venezia';
import ViewEventi from './page/userNotAuth/viewEventi';

// ----- USER AUTHENTICATE ROUTE
import AddEvento from './page/userAuth/addEvento'
import AddEvento2 from './page/userAuth/addEvento2'
import AddArtista from './page/userAuth/addArtista'
import AddFornitore from './page/userAuth/components/fornitori/addFornitore'
import AddArtistSuccess from './page/userAuth/addArtistSuccess'
import AddRisto from './page/userAuth/components/risto/addRisto'
import AddRistoSuccess from './page/userAuth/components/risto/addRistoSuccess'
import AddFoodTruck from './page/userAuth/addFoodTruck'
import AddFoodTruckSuccess from './page/userAuth/addFoodTruckSuccess'
import ConfirmAddEvento from './page/userAuth/confirmAddEvento'
import CreaEvento from './page/userAuth/creaEvento'
import ConfirmEditEvento from './page/userAuth/confirmEditEvento'
import EditArtista from './page/userAuth/editArtista'
import EditArtistaSuccess from './page/userAuth/editArtistaSuccess'
import EditFoodTruck from './page/userAuth/editFoodTruck'
import EditFoodTruckSuccess from './page/userAuth/editFoodTruckSuccess'
import EditEvento1 from './page/userAuth/editEvento1'
import EditEvento2 from './page/userAuth/editEvento2'
import EditRistorante from './page/userAuth/components/risto/editRistorante'
import MyEventiTable from './page/userAuth/myEventiTable'
import ModificaEvento from './page/userAuth/modificaEvento'
import ProfiloArtista from './page/userAuth/profiloArtista'
import ProfiloFoodTruck from './page/userAuth/profiloFoodTruck'
import ProfiloRistorante from './page/userAuth/components/risto/profiloRistorante'
import Preferiti from './page/userAuth/preferiti'
import User from './page/userAuth/user'

// ------ ADMIN ROUTE ---------------------------------------------------------
import AddNewsletter from './page/admin/addNewsletter'
import EditNewsletter from './page/admin/editNewsletter'
import HomeAdmin from './page/admin/homeAdmin'
import CercaEvento from './page/admin/cercaEvento'
import CheckEvent from './page/admin/checkEvent'
import CheckArtisti from './page/admin/checkArtisti'
import CheckFoodTruck from './page/admin/checkFoodTruck'
import CheckRistoranti from './page/admin/checkRistoranti'
import CheckImg from './page/admin/checkImg'
import JpegToBase64 from './page/admin/jpegToBase64'
import VideoCompress from './page/admin/videoCompress'
import EventiByUser from './page/admin/eventiByUser'
import Commenti from './page/admin/commenti'

// ------------- PAYMENT ------------------------------------------------------
import Payment from './page/payment/home'

const router = createBrowserRouter([
  //--------------------------  NOTAUTHENTICATE USER -------------------------------------------------------------  
  { path: '/', element: <Home /> },
  { path: '/artisti', element: <Artisti /> },
  { path: '/cercaFoodTruck', element: <CercaFoodTruck /> },
  { path: '/civita', element: <Civita /> },
  { path: '/eventiDetails/:id', element: <EventiDetails /> },
  { path: '/disabledNotificaEmail/:idEvento/:tipo', element: <DisabledNotificaEmail /> },
  { path: '/fornitori', element: <Fornitori /> },
  { path: '/login', element: <Login /> },
  { path: '/logout', element: <Logout /> },
  { path: '/matera', element: <Matera /> },
  { path: '/newsletter', element: <Newsletter /> },
  { path: '/newsletterDetails', element: <NewsletterDetails /> },
  { path: '/orvieto', element: <Orvieto /> },
  { path: '/reimpostaEmail', element: <ReimpostaEmail /> },
  { path: '/firenze', element: <Firenze /> },
  // { path: '/register', element: <Register /> },
  { path: '/registerSuccess', element: <RegisterSuccess /> },
  { path: '/roma', element: <Roma /> },
  { path: '/reimpostaPassword', element: <ReimpostaPassword /> },
  { path: '/viewEventi', element: <ViewEventi /> },
  { path: '/cosaFare', element: <CosaFare /> },
  { path: '/foodTruck', element: <FoodTruck /> },
  { path: '/foodTruckPerGenere', element: <FoodTruckPerGenere /> },
  { path: '/venezia', element: <Venezia /> },

  //--------------------------  AUTHENTICATE USER -------------------------------------------------------------
  { path: '/addEvento', element: <AddEvento /> },
  { path: '/addEvento2', element: <AddEvento2 /> }, { path: '/confirmAddEvento', element: <ConfirmAddEvento /> },
  { path: '/addFoodTruck', element: <AddFoodTruck /> }, { path: '/addFoodTruckSuccess', element: <AddFoodTruckSuccess /> },
  { path: '/addFornitore', element: <AddFornitore /> },
  { path: '/editFoodTruck', element: <EditFoodTruck /> }, { path: '/editFoodTruckSuccess', element: <EditFoodTruckSuccess /> },
  { path: '/editRistorante', element: <EditRistorante /> },
  { path: '/addArtista', element: <AddArtista /> }, { path: '/addArtistSuccess', element: <AddArtistSuccess /> },
  { path: '/addRisto', element: <AddRisto /> }, { path: '/addRistoSuccess', element: <AddRistoSuccess /> },
  { path: '/editArtista', element: <EditArtista /> }, { path: '/editArtistaSuccess', element: <EditArtistaSuccess /> },
  { path: '/creaEvento', element: <CreaEvento /> }, { path: '/editEvento1', element: <EditEvento1 /> },
  { path: '/myEventiTable', element: <MyEventiTable /> },
  { path: '/editEvento2', element: <EditEvento2 /> }, { path: '/confirmEditEvento', element: <ConfirmEditEvento /> },
  { path: '/modificaEvento', element: <ModificaEvento /> }, { path: '/preferiti', element: <Preferiti /> },
  { path: '/user', element: <User /> },
  { path: '/profiloArtista', element: <ProfiloArtista /> }, { path: '/profiloFoodTruck', element: <ProfiloFoodTruck /> }, { path: '/profiloRistorante', element: <ProfiloRistorante /> },

  //-------------------------- ADMIN --------------------------------------------------------------------------
  { path: '/addNewsletter', element: <AddNewsletter /> }, { path: '/editNewsletter', element: <EditNewsletter /> },
  { path: '/homeAdmin', element: <HomeAdmin /> }, { path: '/checkEvent', element: <CheckEvent /> }, { path: '/jpegToBase64', element: <JpegToBase64 /> },
  { path: '/eventiByUser', element: <EventiByUser /> }, { path: '/videoCompress', element: <VideoCompress /> },
  { path: '/checkImg', element: <CheckImg /> }, { path: '/checkArtisti', element: <CheckArtisti /> },
  { path: '/checkFoodTruck', element: <CheckFoodTruck /> }, { path: '/checkRistoranti', element: <CheckRistoranti /> },
  { path: '/cercaEvento', element: <CercaEvento /> }, { path: '/commenti', element: <Commenti /> },

  //------------------------ PAYMENT ---------------------------------------------------------
  { path: '/payment', element: <Payment /> }
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  // <App />
  // </React.StrictMode>
  <>
    <Provider store={store}>
      <RouterProvider router={router}></RouterProvider>
    </Provider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
